<template>
  <main>
    <Trail
      :list="[
        {
          path: '/proyectos/investigacion',
          name: 'Projects',
          tag: 'Proyectos de Investigación'
        },
        {
          name: 'ANDESPLUS - PERÚ',
          tag: 'ANDESPLUS - PERÚ'
        }
      ]"
    />
    <Container class="container--main">
      <Title tag="h1" align="center">
        ANDESPLUS-PERÚ
      </Title>
      <Title tag="h4" theme="secondary" align="center">
        Evaluación de metodologías y elementos de análisis para el desarrollo de
        proyectos de adaptación al cambio climático en zonas de alta montaña:
        Experiencia de investigación en la subcuenca del río Shullcas - Perú
      </Title>
      <Row>
        <ColumnUi md="9">
          <Navtab id="antecedentes">
            <Title tag="h2">
              Antecedentes
            </Title>
            <p>
              El proyecto "Adaptación al Impacto del Retroceso Acelerado de
              Glaciares en los Andes Tropicales - PRAA", tiene el objetivo de
              reforzar la resiliencia de los ecosistemas y economías locales
              ante los impactos del retroceso glaciar en los Andes Tropicales a
              través de la implementación de actividades piloto que muestren los
              costos y beneficios de la adaptación al cambio climático en
              cuencas seleccionadas en Bolivia, Ecuador y Perú.
            </p>
            <p>
              Para el caso de Perú, las zonas piloto de trabajo son:
            </p>
            <List tag="ol">
              <li>
                Subcuenca del río Shullcas (cuenca del río Mantaro) ➔ Nevado
                Huaytapallana
              </li>
              <li>
                Subcuencas ubicadas en Santa Teresa (cuenca del río Urubamba) ➔
                Nevado Salkantay
              </li>
            </List>
            <p>
              Para el caso de la subcuenca del río Shullcas en particular, y de
              la cuenca del río Mantaro en general, existen trabajos de
              investigación y experiencias relacionadas con adaptación al cambio
              climático que se han venido desarrollando en la zona en los
              últimos años, desde que el proyecto PROCLIM tomara como cuenca
              priorizada a la del Mantaro, cuyo estudio de evaluación integrada
              estuviera a cargo del Instituto Geofísico del Perú.
            </p>
            <p>
              Como parte de las actividades a nivel regional planteadas en el
              marco del PRAA se ha propuesto el desarrollo de una guía
              metodológica para formular las bases científicas que puedan servir
              de base para el diseño y la implementación de medidas de
              adaptación sostenible en zonas de montaña. Esta iniciativa se ha
              denominado ANDESPLUS.
            </p>
            <p>
              Con el fin de contribuir con esta nueva iniciativa, se propone
              desarrollar un caso de estudio en Perú, el que permitirá
              sistematizar la experiencia obtenida en los últimos años en
              trabajos de investigación y ejecución de iniciativas sobre
              vulnerabilidad y adaptación al cambio climático en la cuenca del
              río Mantaro, así como de su experiencia en el trabajo
              multidisciplinario y con diferentes niveles de gobierno de la
              región; contribuyendo de esta manera con la elaboración de la guía
              metodológica propuesta. Esta iniciativa se ha denominado
              ANDESPLUS-PERÚ.
            </p>
          </Navtab>
          <Navtab id="objetivo">
            <Title tag="h2">
              Objetivo
            </Title>
            <p>
              El objetivo de ANDESPLUS-PERÚ es evaluar metodologías para el
              desarrollo de proyectos de adaptación al cambio climático en zonas
              de alta montaña, a través del análisis riguroso de la experiencia
              desarrollada durante los últimos años de trabajo sobre
              vulnerabilidad y adaptación al cambio climático en la cuenca del
              río Mantaro. Se incluirá las experiencias recientes sobre el
              manejo de los recursos hídricos en la subcuenca del río Shullcas.
            </p>
          </Navtab>
          <Navtab id="actividades">
            <Title tag="h2">
              Principales actividades
            </Title>
            <List tag="ol">
              <li>
                Compilación de literatura y bibliografía sobre experiencias
                relacionadas a la vulnerabilidad y el cambio climático en zonas
                andinas del Perú.
              </li>
              <li>
                Revisión de terminologías utilizadas internacionalmente
                (vulnerabilidad, resiliencia, adaptación, gestión de riesgo de
                desastres, etc.), comparación y pertinencia para el caso de la
                zona andina.
              </li>
              <li>
                Diagnóstico de la utilidad y sostenibilidad de técnicas
                tradicionales (i.e. "saberes ancestrales") identificados en
                estudios previos como posibles estrategias de adaptación.
              </li>
              <li>
                Diagnóstico de las experiencias en gestión del agua como
                componente central de las estrategias de adaptación.
              </li>
              <li>
                Diagnóstico de los requerimientos en relación a los escenarios
                climáticos regionalizados ("downscaling") para las zonas andinas
                de Perú, con énfasis en el tipo de información proporcionada,
                horizonte temporal de los escenarios y niveles de incertidumbre.
              </li>
              <li>
                Diagnóstico de la inclusión del tema de cambio climático en los
                instrumentos de planificación local y regional.
              </li>
              <li>
                Diagnóstico de la utilidad de considerar eventos meteorológicos
                extremos como elemento de análisis sobre los potenciales
                impactos del cambio climático en la región andina.
              </li>
              <li>
                Diagnóstico de las metodologías utilizadas para evaluar la
                vulnerabilidad de los diferentes sectores socio-económicos
                potencialmente afectados por el cambio climático en la región
                andina.
              </li>
              <li>
                Comparación de los indicadores de vulnerabilidad generados en
                los diferentes estudios sobre cambio climático realizados para
                la zona andina, u otras iniciativas internacionales reconocidas.
              </li>
              <li>
                Evaluación de diversas metodologías para el desarrollo de
                proyectos de adaptación al cambio climático en zonas de alta
                montaña, tomando como base los resultados de los trabajos
                desarrollados sobre vulnerabilidad y adaptación en la cuenca del
                río Mantaro, con énfasis en la subcuenca del río Shullcas.
              </li>
            </List>
          </Navtab>
          <Navtab id="institucion">
            <Title tag="h2">Institución ejecutora</Title>
            <p>Instituto Geofísico del Perú</p>
          </Navtab>
          <Navtab id="duracion">
            <Title tag="h2">Duración del estudio</Title>
            <p>De agosto de 2011 a abril 2012</p>
          </Navtab>
        </ColumnUi>
        <ColumnUi md="3">
          <Nav :items="navItems" title="Contenido" />
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import Trail from "@/components/common/Trail";
import Title from "@/components/ui/atoms/Title";
import List from "@/components/ui/objects/List";
import Container from "@/components/ui/objects/Container";
import Nav from "@/components/ui/objects/Nav";
import Navtab from "@/components/ui/objects/Navtab";
import Row from "@/components/ui/atoms/Row";
import ColumnUi from "@/components/ui/atoms/ColumnUi";
export default {
  components: {
    Trail,
    Title,
    List,
    Container,
    Nav,
    Navtab,
    Row,
    ColumnUi
  },
  setup() {
    const navItems = [
      {
        path: "#antecedentes",
        tag: "Antecedentes"
      },
      {
        path: "#objetivo",
        tag: "Objetivo"
      },
      {
        path: "#actividades",
        tag: "Principales actividades"
      },
      {
        path: "#institucion",
        tag: "Institución ejecutora"
      },
      {
        path: "#duracion",
        tag: "Duración del estudio"
      }
    ];
    return {
      navItems
    };
  }
};
</script>
